// Sprint T-22 · NotificationSkeleton · loading placeholder
import React from "react";

export const NotificationSkeleton = ({ count = 5 }) => (
  <ul
    className="divide-y divide-[var(--ag-border)]/60"
    data-testid="notif-skeleton"
    aria-hidden="true"
  >
    {Array.from({ length: count }).map((_, i) => (
      <li key={i} className="px-4 py-3 animate-pulse">
        <div className="flex items-start gap-3">
          <div className="mt-1 w-2 h-2 rounded-full bg-[var(--ag-border)]/70" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-3/5 rounded bg-[var(--ag-border)]/60" />
            <div className="h-2.5 w-4/5 rounded bg-[var(--ag-border)]/40" />
            <div className="h-2 w-1/3 rounded bg-[var(--ag-border)]/30" />
          </div>
        </div>
      </li>
    ))}
  </ul>
);

export default NotificationSkeleton;
